import { removeData, storeData } from "../../helper/arrayFormatter";
import { logoutUser, setUser } from "../slices/authSlice";

export const loginUser = async (userData, dispatch) => {
	try {
		dispatch(setUser(userData));
		storeData("user", JSON.stringify(userData));
		storeData("token", userData?.token);
		return true;
	} catch (error) {
		console.log(error);
		return false;
	}
};

export const logoutUserAction = (dispatch) => {
	removeData("user");
	dispatch(logoutUser());
};
